import React from 'react';
import { BrowserRouter, useLocation, useNavigate } from 'react-router';

import { LayoutAdmin } from '@/components/layout/admin';

/**
 * AI.GEN lines=1-15
 * 路由根组件 - 默认跳转到调度工作台
 */
const LayoutRoot = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === '/') {
    setTimeout(() => {
      navigate('/dispatch-workbench');
    }, 0);

    return null;
  }

  return <LayoutAdmin />;
};

export const Router = () => {
  return (
    <BrowserRouter basename={'/'}>
      <LayoutRoot></LayoutRoot>
    </BrowserRouter>
  );
};
